import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ConfigurationService } from '@sondermind/configuration';
import { HttpService } from '@sondermind/http';
import { IAPIListRequestOptions, IAPIListResponse } from '@sondermind/utilities/models-http';

import {
  MemberProviderNetworkCompany,
  IMemberProviderNetworkCompanyAPIResponse
} from '@sondermind/utilities/models-provider-network-company';

@Injectable({
  providedIn: 'root'
})
export class MemberProviderNetworkCompanyService {
  constructor(
    private configurationService: ConfigurationService,
    private http: HttpService,
  ) { }

  index(
    opts: Partial<IAPIListRequestOptions> = {}
  ): Observable<IAPIListResponse<MemberProviderNetworkCompany>> {
    const params = this.http.generateListParams(opts);
    const apiUrl = `${this.configurationService.env.svcBase}/provider_profiles/member_provider_network_companies`;

    return this.http
      .get<IAPIListResponse<IMemberProviderNetworkCompanyAPIResponse>>(apiUrl, params)
      .pipe(
        map(
          (jsonRes) => ({
            meta: jsonRes.meta,
            data: jsonRes.data.map((json) => new MemberProviderNetworkCompany(json))
          } as IAPIListResponse<MemberProviderNetworkCompany>)
        ),
        this.http.handleHttpError()
      );
  }
}
